import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import EmailIdentifierChallengeForm from "./components/EmailIdentifierChallengeForm";
import { useEmailIdentifierChallengeManager } from "./hooks/useEmailIdentifierChallengeManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function EmailIdentifierChallengeScreen() {
    // Extracting attributes from hook made out of EmailIdentifierChallenge instance of Auth0 React ACUL SDK
    const { emailIdentifierChallenge, texts, locales } =
        useEmailIdentifierChallengeManager();

    applyAuth0Theme(emailIdentifierChallenge);
    return (
        <AuthLayout title={texts?.pageTitle || locales?.page?.title}>

            <EmailIdentifierChallengeForm />
            </AuthLayout>
    );
}

export default EmailIdentifierChallengeScreen;
